module.exports = __webpack_public_path__ + "static/media/10-in-our-hnads-1-imposed.66fa3ad7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/10-in-our-hnads-1-imposed.pdf
// module id = 163
// module chunks = 0